import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ApiService } from 'src/app/services/api.service';
import { OtpService } from 'src/app/services/otp.service';
import { SiteContentService } from 'src/app/services/site-content.service';

@Component({
  selector: 'app-validate-otp',
  templateUrl: './validate-otp.component.html',
  styleUrls: ['./validate-otp.component.scss'],
})
export class ValidateOtpComponent implements OnInit {
  @Input() otpId: number;
  @Input() email: string;
  @Input() mobile: string;
  @Input() preferredChannel: string;

  @Output() next = new EventEmitter<{ code: string }>();
  @Output() prev = new EventEmitter();

  @ViewChild('otpForm') otpForm: FormGroup;

  title: string;
  message: string;
  sentMessage: string = "";
  loading: boolean = false;
  otp: string;
  submitted = false;
  error: string;
  errorKey: string;

  constructor(
    private api: ApiService,
    private siteContent: SiteContentService,
    private otpService: OtpService,
    private analyticsService: AnalyticsService
  ) { }

  async ngOnInit() {
    let key = this.preferredChannel === 'Email' ? "QuickQuote.SentEmailOtp" : "QuickQuote.SentSmsOtp";
    this.sentMessage = (await this.siteContent.getSiteContent(key)).body;
    this.title = this.preferredChannel === "Email" ? "Verify Email" : "Verify Mobile";
  }

  async onPrev() {
    this.prev.emit();
  }

  async continue() {
    this.submitted = true;
    this.loading = true;
    try {
      this.message = this.preferredChannel === 'Email' ? 'Verifying your email address' : 'Verifying your mobile phone number';
      const rsp = await this.verify();

      this.otpService.saveVerified(this.preferredChannel === 'Email' ? this.email : this.mobile, rsp.code);
      this.analyticsService.logEvent('quickquote:otp_validated', { channel: this.preferredChannel });
      this.next.emit({ code: rsp.code });
    } catch (err: any) {
      if (err.message != "Invalid OTP")
        this.errorKey = "FullQuote.Error";
      this.error = err.message;
      this.analyticsService.logEvent('quickquote:otp_invalid', { channel: this.preferredChannel });
    }
    finally {
      this.loading = false;
    }
  }

  async verify() {
    return await this.api.verifyOtpQuickQuote(
      {
        otpId: this.otpId,
        email: this.email,
        mobile: this.mobile,
        otp: this.otp
      });
  }
}
